module.exports = {
  header: {
    home: '首页',
    about: '关于我们',
    products: '产品及案例',
    solutions: '服务',
    partner: '合作伙伴',
    contact: '联系我们',
    button: 'EN'
  },
  slide: {
    title1: '客户至上',
    title2: '精益求精',
    title3: '团队合作',
    title4: '社会责任',
    text1: '以客户的利益与需求为本，追求互利共赢',
    text2: '厚德至诚，精工至善，创新致远，实干争先',
    text3: '高效运作，默契配合，精英团队，活力无限',
    text4: '慈善送温暖，爱心献社会，真情永千秋',
    read_more: '了解更多'
  },
  about: {
    title: '关于我们',
    // title_text: '亿企云，Salesforce 合作伙伴',
    title_text: '成都亿企云科技有限公司',
    title1: '国家科技型中小企业',
    text1: '公司网络分布：成都、上海、深圳',
    title2: '团队构成',
    text2: '创始人：国内Top8毕业，技术专家 合伙人：MBA，20年+外企IT经验',
    title3: '使命愿景',
    text3: '亿万企业上云，用科技赋能企业发展',
    title4: '公司文化',
    text4: '客户至上，精益求精，团队合作，社会责任',
    // text1:'Salesforce 是世界上排名第一的客户关系管理(CRM)平台。面向销售、服务、营销等领域,其软件基于云端，因此用户不需要IT专家团队进行安装设置或管理，只需登陆即可使用。让您以一种全新的方式与客户交互。Salesforce 帮助您构建更有意义更持久的客户关系，更快地帮助客户解决问题,真正做到以客户为中心。',
    // text2:'Salesforce Lightning 是一种更高效的工作方式，也是一种更快构建应用程序的平台。Lightning Experience 让用户每时每刻都更加高效，提供一种快速的用户新体验。开发人员可使用 Lightning Developer Services 可针对任意或全部用例快速启动应用程序，因为您可轻松跨组件重用代码，而不会破坏您的自定义设置。'
  },
  products: {
    title: '产品及案例',
    title_text: '基于现代企业数字化需求，提供极具竞争力的云计算产品和服务',
    item1: '供应链管理',
    item1_subTitle: '基于云计算和IoT的高值耗材多种供应链模式的管理系统：',
    item1_text: `
        提升了供应链物流、信息流和财务流动效率,
        智能化的物联网（IoT）降低工作负荷，减少差错,
        与ERP等原有系统集成，保证业务信息无缝传递`,
    item2: '订单系统',
    item2_subTitle: '中国油气和化工部门核心业务系统：',
    item2_text: `
        单系统多职能全流程集中化管理，一个系统解决所有问题，
        支持800+ 并发用户，
        与中国区、全球公司网络全方位集成，连接信息孤岛，
        开结单时长从一两周缩短至3-5天`,
    item3: '校友平台',
    item3_subTitle: '微信集成校友服务平台：',
    item3_text: `
        机构和校友双侧管理校友简历、职业轨迹、求职意向,
        智能职位推荐，支持校友一键投递,
        促进校友了解机构动态，方便组织线上线下活动,
        校友社交，促进跨届跨区域校友交流`,
    item4: '选拔和管理系统',
    item4_subTitle: '未来之星教育创业项目和创客选拔和管理系统：',
    item4_text: `
        申请、初试、复试、录取流程自动化,
        自动通知申请人、内外部面试官，减少沟通成本,
        多维度信息管理，自动获取项目融资最新情况,
        洞察整个选拔过程、提供对项目和创客的可视化展示`,
    item5: '信件管理小程序',
    item5_subTitle: '信件电子化小程序和后台管理系统：',
    item5_text: `
        提高项目执行效率，提升项目透明度,
        小程序平台，方便老师和志愿者交流,
        志愿者与儿童智能配对，大大提升效率,
        公益项目，实践企业社会责任`,
    item6: '打印程序',
    item6_subTitle: '多文档批量打印App：',
    item6_text: `
        自主研发的PC端多文档批量打印系统,
        批量添加和打印本地文档,
        通过标准化接口，下载并打印网上文档`,
    // sales:'销售',
    // service:'服务',
    // platform:'应用程序',
    // marketing:'市场',
    // commerce:'贸易',
    // internet:'物联网',
    // sales_text:'借助全球首屈一指的CRM解决方案，您的销售团队能够借助客户成功平台上一系列基于云平台的销售工具，以前所未有的方式完成交易。这些工具可提高工作效率，为销售漏斗填充可靠的销售线索，并提高销售成功率。基于云平台的销售产品，让您无需软件安装、无需硬件升级，而且不受速度限制，随时随地开展销售工作。',
    // service_text:'我们的客户服务解决方案 从呼叫中心软件延伸到自助服务门户，通过更快、更直观、更灵活的支持来预测客户需求，进而改善您的客户服务。基于云计算的云服务应用提供更快、更智能的服务，让客户获得应有的支持。连接您整个工作团队以提供智能、高效的现场服务，并改善客户的现场体验。',
    // platform_text:'如今，每家公司都在开展应用程序业务。通过应用程序，您的客户能够了解您的品牌，员工能够相互联络沟通，业务流程能够在企业上下实现精简化、自动化和移动化。Salesforce Platform 是您的云计算应用一站式商店，用于构建、运行、管理和优化应用程序，同时利用平台上的技术和专业知识为我们的成功起到了助推作用。',
    // marketing_text:'通过云平台获取客户数据，充分利用每次客户互动，打造个性化、跨渠道的客户之旅。通过电子邮件、移动、社交、广告、网络等不同营销平台渠道传递卓越的客户体验。使用全球最强大的云端数字营销平台 ，打造一对一的客户体验之旅。',
    // commerce_text:'借助云平台整合所有商务渠道的客户体验：包括Web、社交、手机、商店等不同商务渠道，从购物、订单履行到客户服务，这一切都可通过内置预测性智能，为客户制定一对一的购物体验。利用我们完整的商务解决方案在所有数字渠道从事营销、销售、促销、订单履行等活动，与购物者进行交互。',
    // item8:'信件电子化小程序和后台管理系统',
    // internet_text:'通过云平台将物联网与最重要的客户数据连接，主动与客户互动，以便采取更有意义的实时行动。借助云平台上的应用程序，您可连接任何设备、传感器、产品、网站和事件数据流。利用功能强大而直观的工具Salesforce IoT，将物联网连接到Salesforce上，从而将大数据转换为实时行动。'
  },
  industry: {
    title: '我们的服务',
    title_text: '透过行业深度见解和高可靠服务，助您的成功一臂之力',
    ins_title: '企业业务系统开发和集成',
    automative: '汽车',
    communication: '通讯',
    financial: '金融',
    medical: '医疗',
    media: '媒体',
    retail: '零售',
    education: '教育',
    manufacturing: '制造业',
    automative_text: '以前所未有的方式与客户和潜在客户互动。 ',
    communication_text: '实现一对一沟通。',
    financial_text: '金融服务的未来蕴藏于此。',
    medical_text: '将患者关系和医疗创新提升到新的高度。',
    media_text: '抛弃陈旧的媒体模型。',
    retail_text: '将各个方面的业务都集成到一个智能平台上。',
    education_text: '利用教育CRM实现社交、移动和云服务技术，打造互联校园。',
    manufacturing_text: '通过大规模个性化服务，突破产品局限。',
    Salesforce_industy_titie:"CRM、Salesforce咨询",
    Salesforce_industy1: "您需要客户关系管理(CRM)",
    Salesforce_industy1_text1: "CRM 旨在使您的客户感到满意;",
    Salesforce_industy1_text2: "CRM 涵盖您与客户进行沟通的所有方面，并增强您与客户之间的互动，从销售到市场营销到客户服务; ",
    Salesforce_industy1_text3: "从而满足所有业务成功的核心要求。",
    // Salesforce_industy2: "我们是Salesforce合作伙伴",
    Salesforce_industy2: "Salesforce咨询",
    Salesforce_industy2_text1: "Salesforce 是全球首屈一指的CRM平台;",
    Salesforce_industy2_text2: "销售云、服务云、社区云等产品的采购和实施;",
    Salesforce_industy3: "PaaS客制化开发和培训",
    Salesforce_industy3_text1: "根据您企业业务客制化系统，100%契合实际业务",
    Salesforce_industy3_text2: "可以将您核心业务系统纳入平台，业务上云",
    Salesforce_industy3_text3: "将企业其他系统集成一处，数据的统一化管控",
    Salesforce_industy3_text4: "提供管理员、开发人员培训，授您以渔",
    Salesforce_industy_des:"客户关系管理 (CRM) 旨在管理您企业最重要的目标 – 使您的客户感到满意。高度有效的客户关系管理系统(CRM系统)将涵盖您与客户进行沟通的所有方面，并增强您与客户之间的互动，从销 售到市场营销到客户服务:让您与现有的客户关系变得更加稳固，而与新客户的关系则有更加快速的进展 – 满足所有业务成功的核心要求。 Salesforce是全球首屈一指的CRM平台，根据 IDC 2018H1 全球市场收入份额，Salesforce 在 CRM 应用程序中排名第一。",

    tec_title: '技术优势',
    heading1: 'PaaS平台',
    heading1_text1: `1、云平台提升了开发速度，保证了系统稳定，降低了IT维护成本`,
    heading1_text2: `2、阿里云、微软云、亚马逊AWS、Salesforce 闪电平台 开发支持`,
    heading1_text3: `3、根据企业实际情况，帮助企业选择最优的平台并交付相应软件`,
    heading2: '后端技术',
    heading2_text1: `1、支持 Java, .NET, Python等主流语言和相应框架`,
    heading2_text2: `2、可根据企业现有IT架构选择相关技术和框架，确保IT资源延续性`,
    heading2_text3: `3、企业内外部系统集成（数据集成、业务集成）`,
    heading3: '前端技术',
    heading3_text1: `1、电脑和手机端的 HTML5 网页业务平台或网站开发`,
    heading3_text2: `2、小程序、PC端程序、手机App开发`,
    heading3_text3: `3、支持原生JS、React、VUE等前端框架`,
    flow_title: '服务流程',
    flow_flow1_title: '需求收集',
    flow_flow1_text: '与相关部门密切合作，全面挖掘和整理显隐形需求',
    flow_flow2_title: '分析设计',
    flow_flow2_text: '将需求转换为模型，架构和业务规则',
    flow_flow3_title: '开发测试',
    flow_flow3_text: '软件的开发，集成缺陷的发现，调试和修正',
    flow_flow4_title: '上线培训',
    flow_flow4_text: '系统的安装及迁移，多种维度和深度的用户培训',
    flow_flow5_title: '持续优化',
    flow_flow5_text: '支持和维护不断优化系统的方方面面',
    pattern_title: '服务模式',
    pattern_item1: '基于文档',
    pattern_item1_text1: '传统 IT 项目模式',
    pattern_item1_text2: '根据需求制订详尽设计和开发计划',
    pattern_item1_text3: '以整体项目方式交付',
    pattern_item1_text4: '项目中途需求调整代价大',
    pattern_item1_title: '瀑布流',
    pattern_item2: '基于沟通',
    pattern_item2_text1: '最新的、领先的交付方式',
    pattern_item2_text2: '小周期，大循环，快速迭代',
    pattern_item2_text3: '极大的效率和需求变更容忍度',
    pattern_item2_text4: '高质量的项目和软件交付',
    pattern_item2_title: '敏捷',
  },
  team: {
    title: '亿企云团队',
    title_text: '我们的团队积极上进、团结合作、充满活力',
    person1: 'George, CEO',
    person1_text: '自信是成功的第一诀窍',
    person2: 'Jack, 合伙人',
    person2_text: '困难里包含着胜利，失败里孕育着成功',
    person3: 'James, 架构',
    person3_text: '成功的秘诀，在永不改变既定的目的',
    person4: 'Eva, 经理',
    person4_text: ' 成功的秘诀，在于随时随地把握时机',
    person5: 'Kanye, 主管',
    person5_text: '哪儿有勤奋，哪儿就有成功',
    person6: 'Sandy, 资深开发',
    person6_text: '书山有路勤为径，学海无涯苦作舟。',
    person7: 'Jane, 开发',
    person7_text: '忍耐虽然痛苦，果实却最香甜',
    person8: 'Alex, 开发',
    person8_text: '为把明天的工作做好，最好的准备是把今天的工作做好',
  },
  contact: {
    title: '联系我们',
    title_text: '位于中国成都，服务全球的合作伙伴',
    address: '中国成都高新区美年广场C609',
    contactinfo: '联系我们',
    name: '姓名',
    email: '邮箱',
    message: '您的需求',
    send: '呼叫亿企云',
    received: '成功，我们会尽快与您联系',
    qrcode: '扫描二维码,关注亿企云'
  },
  footer: {
    copyright: '© 2023 成都亿企云科技有限公司保留所有权利.',
    AQ: '蜀ICP备18019677号-1',
    erweima_text: '扫一扫,关注亿企云',
    promise_text: '亿企云从创建之初就关注公益,我们承诺将我们1%的技术、人力以及资源用于社会公益事业，帮助我们的世界变得更美好'
  },
  partner: {
    title: '亿企云合作伙伴',
    title_text: '认真聆听、收集并积极响应合作伙伴的需求，建立以合作伙伴为中心的交付框架',
    partner1: '北京立德未来助学公益基金会',
    partner1_text: '我们为教育资源匮乏地区提供持续稳定的师资力量，让所有中国孩子, 无论出身, 都能获得同等的优质教育!',
    partner2: '宽岳医疗生物科技有限公司',
    partner2_text: '我们相信，真正从无到有的研发是产品的“灵魂”, 生而不凡, b-ONE是全球高端骨科的自主创新力量！',
    partner3: '北京世纪好未来教育科技有限公司',
    partner3_text: '运用全球范围内先进的理念和技术，让每一个人都能享有公平而有质量的教育，实现人生梦想!',
    partner4: '通标标准技术服务有限公司',
    partner4_text: '全球领先的检验、鉴定、测试和认证机构。无论您从事什么行业，SGS都能为您提供专业的业务解决方案！',
    partner5: '上海至美公益基金会',
    partner5_text: '倡导和支持大学生志愿服务，与高校合作开展志愿服务学习课程，集结与撬动社会资源，实现人人可公益!',
    partner6: '极狐信息技术（湖北）有限公司',
    partner6_text: '10万企业使用的一站式DevOps平台。极狐GitLab中文官网，提供企业级源代码管理。',
    partner7: '北京市海淀区高山科学促进中心',
    partner7_text: '开展与前沿科学相关的学术研究、学术交流、技术推广、专业培训，承接政府与委托服务。',
    partner8: '重庆市科旭制药机械设备制造有限公司',
    partner8_text: '重庆市科旭制药机械设备制造有限公司专业于固体制剂混合、制粒、制微丸、微丸包衣、干燥以及物料密闭输送设备的研制、开发、生产销售的企业。'
  },
}



// WEBPACK FOOTER //
// ./src/lang/zh.js